'use client'

import { clientPage } from '../_lib/clientPage'

// Home (`/`). HomeView handles its own auth branching: authed → dashboard
// redirect; unauthenticated → marketing site when NEXT_PUBLIC_WEB_URL is set,
// otherwise renders the public home content.
export default clientPage(() =>
  import('@/components/views/HomeView').then((m) => ({
    default: m.HomeView,
  }))
)
